// extracted by mini-css-extract-plugin
module.exports = {"pdp_offer_option":"indexoptions_pdp_offer_option__e2rWN"};